module.exports = __webpack_public_path__ + "img/featuredartist15 (3).06873a70.jpg";